<template>
    <div class="main-layout">
        <!-- 顶部导航栏 -->
        <div class="top-navbar">
            <div class="navbar-left">
                <img src="/logo.png" class="logo" alt="Logo" onerror="this.style.display='none'" />
                <h1 class="system-title">羊驼考务 - 招录管理系统</h1>
            </div>
            <div class="navbar-right">
                <div class="school-info">
                    <i class="el-icon-school"></i>
                    <span>{{ adminInfo.yxmc || '当前院校' }}</span>
                </div>
                <el-select v-model="currentYear" placeholder="选择年份" size="small" @change="onYearChange" class="year-selector">
                    <el-option v-for="year in yearList"
                               :key="year"
                               :label="year + '年'"
                               :value="year">
                    </el-option>
                </el-select>
                <div class="user-info">
                    <i class="el-icon-user"></i>
                    <span>{{ adminInfo.name || '管理员' }}</span>
                </div>
                <el-button type="text" @click="logout" class="logout-btn">
                    <i class="el-icon-switch-button"></i> 退出
                </el-button>
            </div>
        </div>

        <div class="main-content">
            <!-- 左侧菜单 -->
            <div class="side-menu">
                <el-menu :default-active="activeMenu"
                         class="el-menu-vertical"
                         @select="handleMenuSelect"
                         background-color="#2c3e50"
                         text-color="#bdc3c7"
                         active-text-color="#409EFF">

                    <!-- 数据导入模块 -->
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-upload"></i>
                            <span>数据导入</span>
                        </template>
                        <el-menu-item index="/Data/ImportData">
                            <i class="el-icon-document-add"></i>
                            <span>导入考生数据</span>
                        </el-menu-item>
                        <el-menu-item index="/Data/ImportPhoto">
                            <i class="el-icon-picture"></i>
                            <span>导入考生照片</span>
                        </el-menu-item>
                        <el-menu-item index="/Data/ImportTjb">
                            <i class="el-icon-files"></i>
                            <span>导入体检表</span>
                        </el-menu-item>
                    </el-submenu>

                    <!-- 数据处理模块 -->
                    <el-submenu index="2">
                        <template slot="title">
                            <i class="el-icon-setting"></i>
                            <span>数据处理</span>
                        </template>
                        <el-menu-item index="/Dict/ManageDict">
                            <i class="el-icon-folder-opened"></i>
                            <span>维护字典</span>
                        </el-menu-item>
                        <el-menu-item index="/Dict/CorrectData">
                            <i class="el-icon-edit"></i>
                            <span>数据修正</span>
                        </el-menu-item>
                    </el-submenu>

                    <!-- 数据管理模块 -->
                    <el-submenu index="3">
                        <template slot="title">
                            <i class="el-icon-s-order"></i>
                            <span>数据管理</span>
                        </template>
                        <el-menu-item index="/Info/ListSanBiao">
                            <i class="el-icon-document"></i>
                            <span>三表管理</span>
                        </el-menu-item>
                        <el-menu-item index="/Info/FileManage">
                            <i class="el-icon-folder-opened"></i>
                            <span>文件管理</span>
                        </el-menu-item>
                    </el-submenu>

                    <!-- 录取通知书管理 -->
                    <el-submenu index="4">
                        <template slot="title">
                            <i class="el-icon-message"></i>
                            <span>通知书管理</span>
                        </template>
                        <el-menu-item index="/Notice/ExpressList">
                            <i class="el-icon-truck"></i>
                            <span>快递单号管理</span>
                        </el-menu-item>
                        <el-menu-item index="/Notice/NoticeExport">
                            <i class="el-icon-download"></i>
                            <span>通知书导出</span>
                        </el-menu-item>
                        <el-menu-item index="/Notice/NoticeDownload">
                            <i class="el-icon-folder-opened"></i>
                            <span>通知书下载</span>
                        </el-menu-item>
                    </el-submenu>

                    <!-- 数据分析统计 -->
                    <el-submenu index="5">
                        <template slot="title">
                            <i class="el-icon-data-analysis"></i>
                            <span>数据分析</span>
                        </template>
                        <el-menu-item index="/Analysis/Dashboard">
                            <i class="el-icon-s-data"></i>
                            <span>数据概览</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/Province">
                            <i class="el-icon-location"></i>
                            <span>省份分析</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/Major">
                            <i class="el-icon-school"></i>
                            <span>专业分析</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/Score">
                            <i class="el-icon-trophy"></i>
                            <span>分数分析</span>
                        </el-menu-item>
                        <el-submenu index="5-5">
                            <template slot="title">
                                <i class="el-icon-s-order"></i>
                                <span>志愿分析</span>
                            </template>
                            <el-menu-item index="/Analysis/FirstVolunteer">
                                <i class="el-icon-star-on"></i>
                                <span>一志愿率分析</span>
                            </el-menu-item>
                            <el-menu-item index="/Analysis/TransferRate">
                                <i class="el-icon-refresh-right"></i>
                                <span>调剂率分析</span>
                            </el-menu-item>
                            <el-menu-item index="/Analysis/VolunteerComposition">
                                <i class="el-icon-s-grid"></i>
                                <span>志愿组成</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item index="/Analysis/HighSchool">
                            <i class="el-icon-office-building"></i>
                            <span>生源高中分析</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/StudentType">
                            <i class="el-icon-user-solid"></i>
                            <span>考生类别分析</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/Ethnicity">
                            <i class="el-icon-s-custom"></i>
                            <span>民族分析</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/Custom">
                            <i class="el-icon-search"></i>
                            <span>自定义分析</span>
                        </el-menu-item>
                        <el-menu-item index="/Analysis/Report">
                            <i class="el-icon-document"></i>
                            <span>生成录取报告</span>
                        </el-menu-item>
                    </el-submenu>

                    <!-- 教育调查表 -->
                    <el-submenu index="6">
                        <template slot="title">
                            <i class="el-icon-s-marketing"></i>
                            <span>教育调查表</span>
                        </template>
                        <el-menu-item index="/Survey/Type">
                            <i class="el-icon-tickets"></i>
                            <span>招生类别情况</span>
                        </el-menu-item>
                        <el-menu-item index="/Survey/Standard">
                            <i class="el-icon-reading"></i>
                            <span>录取标准及人数</span>
                        </el-menu-item>
                        <el-menu-item index="/Survey/Major">
                            <i class="el-icon-notebook-2"></i>
                            <span>专业招生报到</span>
                        </el-menu-item>
                    </el-submenu>

                    <!-- 公共数据查询 -->
                    <el-menu-item index="/Public/ScoreLine">
                        <i class="el-icon-document-copy"></i>
                        <span>投档线查询</span>
                    </el-menu-item>

                    <!-- 关于系统 -->
                    <el-menu-item index="/System/About">
                        <i class="el-icon-info"></i>
                        <span>关于系统</span>
                    </el-menu-item>
                </el-menu>
            </div>

            <!-- 右侧内容区 -->
            <div class="content-area">
                <!-- 面包屑导航 -->
                <div class="breadcrumb-container">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/Dashboard' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item v-for="item in breadcrumbs" :key="item.path">
                            {{ item.name }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>

                <!-- 页面内容 -->
                <div class="page-content">
                    <router-view></router-view>
                </div>
            </div>
        </div>

        <!-- 页脚 -->
        <div class="footer">
            <p>© 2025 羊驼考务 - 招录管理系统 | 技术支持</p>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';

    export default {
        name: 'MainLayout',
        data() {
            return {
                currentYear: 2025,
                yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026],
                activeMenu: '',
                adminInfo: {
                    name: '',
                    phone: '',
                    yxdm: ''
                },
                breadcrumbs: []
            };
        },
        methods: {
            handleMenuSelect(index) {
                if (this.$route.path === index) return;
                this.$router.push(index).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.updateBreadcrumbs(index);
            },
            onYearChange(year) {
                // 切换年份后刷新当前页面数据
                this.$emit('year-change', year);
                // 可以通过事件总线通知所有子组件
                this.$root.$emit('global-year-change', year);
            },
            updateBreadcrumbs(path) {
                const menuMap = {
                    '/Data/ImportData': [{ name: '数据导入' }, { name: '导入考生数据' }],
                    '/Data/ImportPhoto': [{ name: '数据导入' }, { name: '导入考生照片' }],
                    '/Data/ImportTjb': [{ name: '数据导入' }, { name: '导入体检表' }],
                    '/Dict/ManageDict': [{ name: '数据处理' }, { name: '维护字典' }],
                    '/Dict/CorrectData': [{ name: '数据处理' }, { name: '数据修正' }],
                    '/Info/ListSanBiao': [{ name: '数据管理' }, { name: '三表管理' }],
                    '/Info/FileManage': [{ name: '数据管理' }, { name: '文件管理' }],
                    '/Notice/ExpressList': [{ name: '通知书管理' }, { name: '快递单号管理' }],
                    '/Notice/NoticeTemplate': [{ name: '通知书管理' }, { name: '通知书模板' }],
                    '/Notice/NoticePrint': [{ name: '通知书管理' }, { name: '通知书打印' }],
                    '/Notice/NoticeExport': [{ name: '通知书管理' }, { name: '通知书导出' }],
                    '/Notice/NoticeDownload': [{ name: '通知书管理' }, { name: '通知书下载' }],
                    '/Analysis/Dashboard': [{ name: '数据分析' }, { name: '数据概览' }],
                    '/Analysis/Province': [{ name: '数据分析' }, { name: '省份分析' }],
                    '/Analysis/Major': [{ name: '数据分析' }, { name: '专业分析' }],
                    '/Analysis/Score': [{ name: '数据分析' }, { name: '分数分析' }],
                    '/Analysis/FirstVolunteer': [{ name: '数据分析' }, { name: '志愿分析' }, { name: '一志愿率分析' }],
                    '/Analysis/TransferRate': [{ name: '数据分析' }, { name: '志愿分析' }, { name: '调剂率分析' }],
                    '/Analysis/VolunteerComposition': [{ name: '数据分析' }, { name: '志愿分析' }, { name: '志愿组成' }],
                    '/Analysis/HighSchool': [{ name: '数据分析' }, { name: '生源高中分析' }],
                    '/Analysis/StudentType': [{ name: '数据分析' }, { name: '考生类别分析' }],
                    '/Analysis/Ethnicity': [{ name: '数据分析' }, { name: '民族分析' }],
                    '/Analysis/Custom': [{ name: '数据分析' }, { name: '自定义分析' }],
                    '/Analysis/Report': [{ name: '数据分析' }, { name: '生成录取报告' }],
                    '/Survey/Type': [{ name: '教育调查表' }, { name: '招生类别情况' }],
                    '/Survey/Standard': [{ name: '教育调查表' }, { name: '录取标准及人数' }],
                    '/Survey/Major': [{ name: '教育调查表' }, { name: '专业招生报到' }],
                    '/Public/ScoreLine': [{ name: '投档线查询' }],
                    '/System/About': [{ name: '关于系统' }]
                };
                this.breadcrumbs = menuMap[path] || [];
            },
            logout() {
                this.$confirm('确定要退出登录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 清除登录信息
                    sessionStorage.clear();
                    localStorage.clear();
                    // 跳转到登录页
                    this.$router.push('/Login');
                }).catch(() => { });
            },
            fetchUserInfo() {
                const api_name = '/Admin/GetUserInfo';
                const url = TYBM_Env.GetApiUrl(api_name);

                TYBM_Tools.AxiosPostEx(this, api_name, url, {}, { loading: false, show_error: false })
                    .then(response => {
                        const data = response.data;
                        this.adminInfo = {
                            name: data.AdminName,
                            phone: data.Phone,
                            yxdm: data.YXDM,
                            yxmc: data.YXMC
                        };
                        this.yearList = data.AvailableYears || [];
                        this.currentYear = data.Year;

                        // 如果当前年份不在列表中，添加进去（防止显示为空）
                        if (this.yearList.indexOf(this.currentYear) === -1) {
                            this.yearList.unshift(this.currentYear);
                        }

                        // 通知 App.vue 更新全局年份
                        this.$root.$emit('global-year-change', this.currentYear);
                    })
                    .catch(error => {
                        // 如果是未登录错误，跳转到登录页
                        if (error.code === 'error' && (error.errmsg === '未登录' || error.errmsg.includes('无权访问'))) {
                            this.$message.error(error.errmsg);
                            this.$router.push('/Login');
                        } else {
                            console.error('获取用户信息失败', error);
                            this.$router.push('/Login');
                        }
                    });
            }
        },
        watch: {
            '$route'(to) {
                this.activeMenu = to.path;
                this.updateBreadcrumbs(to.path);
            }
        },
        mounted() {
            this.activeMenu = this.$route.path;
            this.updateBreadcrumbs(this.$route.path);

            // 获取管理员信息和年份信息
            this.fetchUserInfo();
        }
    };
</script>

<style scoped>
    .main-layout {
        display: flex;
        flex-direction: column;
        height: 100vh;
        overflow: hidden;
        background-color: #f5f7fa;
    }

    .top-navbar {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .navbar-left {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .logo {
        height: 40px;
        width: auto;
    }

    .system-title {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        letter-spacing: 1px;
    }

    .navbar-right {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .school-info {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 500;
    }

    .year-selector {
        width: 120px;
    }

        .year-selector > > > .el-input__inner {
            background-color: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.3);
            color: white;
        }

    .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
    }

    .logout-btn {
        color: white !important;
        font-size: 14px;
    }

        .logout-btn:hover {
            opacity: 0.8;
        }

    .main-content {
        display: flex;
        flex: 1;
        overflow: hidden;
    }

    .side-menu {
        width: 240px;
        background-color: #2c3e50;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    }

        .side-menu::-webkit-scrollbar {
            width: 6px;
        }

        .side-menu::-webkit-scrollbar-track {
            background: #1a252f;
        }

        .side-menu::-webkit-scrollbar-thumb {
            background: #34495e;
            border-radius: 3px;
        }

            .side-menu::-webkit-scrollbar-thumb:hover {
                background: #4a5f7f;
            }

    .el-menu-vertical {
        border-right: none;
    }

        .el-menu-vertical > > > .el-submenu__title {
            height: 50px;
            line-height: 50px;
        }

        .el-menu-vertical > > > .el-menu-item {
            height: 45px;
            line-height: 45px;
        }

    .content-area {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .page-content {
        flex: 1;
        padding: 10px 20px 20px 20px;
        overflow-y: auto;
        overflow-x: hidden;
    }

        .page-content::-webkit-scrollbar {
            width: 8px;
        }

        .page-content::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        .page-content::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
        }

            .page-content::-webkit-scrollbar-thumb:hover {
                background: #555;
            }

    .footer {
        background-color: #2c3e50;
        color: white;
        text-align: center;
        padding: 16px;
        font-size: 14px;
    }

        .footer p {
            margin: 0;
        }

    @media (max-width: 768px) {
        .side-menu {
            width: 200px;
        }

        .system-title {
            font-size: 16px;
        }

        .page-content {
            padding: 10px;
        }
    }
</style>

